import { useAutoAnimate } from "@formkit/auto-animate/react";
import React from "react";
import { Card, Row } from "react-bootstrap";
import SeleccionMascota from "./SeleccionMascota/SeleccionMascota";
import { defaultModel } from "./Model";

function Pasos() {
  const [animationParent] = useAutoAnimate<HTMLDivElement>();

  return (
    <Row className="justify-content-center">
      <div className="col-xs-12 col-md-10 col-lg-10 col-xxl-5">
        <Card>
          <Card.Body ref={animationParent}>
            <SeleccionMascota model={defaultModel} />
          </Card.Body>
        </Card>
      </div>
    </Row>
  );
}

export default Pasos;
